import { faComment, faPercent } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import i18n from "../../../../constants/i18n";
import getFlaggedDesctiprionStore from "../../../../stores/supervisor-store/flagged-description-store";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const FlaggedDescriptions = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const isEnabled =
    getFlaggedDesctiprionStore().allowAddingFlaggedDescription.get();

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="row"
        justifyContent="space-between"
        alignItems="center"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={false}
          type={"textarea"}
          icon={faComment}
          label={i18n.get("ADD_DESCRIPTION")}
          placeHolder={i18n.get("ADD_DESCRIPTION")}
          value={getFlaggedDesctiprionStore().flaggedDescriptionsText.get()}
          onChoose={(value) => {
            getFlaggedDesctiprionStore().setflaggedDescriptionsText(value);
          }}
          onBlur={() => {}}
          onEnter={() => {}}
          style={{}}
        />
        <Et3TextInput
          size="MEDIUM"
          withShadow={false}
          type={"number"}
          icon={faPercent}
          label={""}
          placeHolder={""}
          value={getFlaggedDesctiprionStore().flaggedDescriptionsPercentage.get()}
          onChoose={(value) => {
            getFlaggedDesctiprionStore().setflaggedDescriptionsPercentage(
              value
            );
          }}
          onBlur={() => {}}
          onEnter={() => {}}
          style={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        onClick={() => {
          getFlaggedDesctiprionStore().addFlaggedDescriptions();
        }}
        isEnabled={isEnabled}
        size="LARGE"
        text="SUBMIT"
        type="WARN"
      >
        {i18n.get("SUBMIT")}
      </Et3Button>
    </React.Fragment>
  );
});
export default FlaggedDescriptions;
